import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import {SavedCard} from "../types/PaymentCard";
import {ME_BASE_URL} from "../../../config/config";

export const PAYMENT_CARDS_CACHE_KEY = "payment-cards";

export default function usePaymentCardsGet(
    options?: CacheQueryOpts<SavedCard[]>
): CacheQueryOutput<SavedCard[]> {
    const client = useAPIClient(ME_BASE_URL, false);

    return useCacheQuery<SavedCard[]>(
        [PAYMENT_CARDS_CACHE_KEY],
        () => client.get<SavedCard[]>("payment_cards"),
        options
    );
}

